import React from 'react';
import { useTranslation } from 'react-i18next';

import useDrawerControls from 'hooks/useDrawerControls';
import ChangeCurrencyDrawer from './ChangeCurrencyDrawer/ChangeCurrencyDrawer';

import TrackerCheckout from 'utils/Tracker.checkout';
import * as S from './ChangeCurrency.styles';

export const ChangeCurrency: React.FC = () => {
  const { isOpen, closeDrawer, openDrawer } = useDrawerControls();
  const { t } = useTranslation();

  const handleOpenDrawer = () => {
    TrackerCheckout.changeCurrency();
    openDrawer();
  };

  return (
    <S.ChangeCurrencyContainer>
      <S.StyledText>{t('changeCurrency.payInOtherCountries')}</S.StyledText>
      <S.HighlightedText
        variant="link"
        onClick={handleOpenDrawer}
        data-testid="change-currency-btn"
      >
        {t('changeCurrency.changeCurrency')}
      </S.HighlightedText>
      <ChangeCurrencyDrawer isOpen={isOpen} closeDrawer={closeDrawer} />
    </S.ChangeCurrencyContainer>
  );
};
